import { t } from "@lingui/macro";
import { useSetAtom } from "jotai";

import { ReloadIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { enterSwapPlayersBetweenGroupsStepAtom } from "../../../../../../../../../atoms/actions/enterSwapPlayersBetweenGroupsStepAtom/enterSwapPlayersBetweenGroupsStepAtom";

type Props = {
  roundId: string;
  closeMenu: () => void;
};

export const SwapPlayersBetweenGroupsMenuItem = ({
  roundId,
  closeMenu,
}: Props) => {
  const enterSwapStep = useSetAtom(enterSwapPlayersBetweenGroupsStepAtom);

  return (
    <Pressable
      testID="swap-players-between-groups-menu-item"
      onPress={() => {
        enterSwapStep({ roundId });
        closeMenu();
      }}
    >
      <HStack gap={3} paddingHorizontal={4} paddingVertical={3}>
        <ReloadIcon />
        <Text>{t`Swap with another player`}</Text>
      </HStack>
    </Pressable>
  );
};
